import React, { CSSProperties, useCallback, useEffect, useRef } from "react";
import { Button, Card } from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useStyle } from "../../listChats/styles";
import { formatDate } from "../../../../../utils/utils";
import { TMessageGPT } from "../hooks/useGetMessagesGPT";
import { IUser } from "../../../../../interfaces/users";
import Preloader from "../../../../../components/ui/Loaders/Preloader";
import { useIntl } from "react-intl";

interface IProps {
  loadingMessages: boolean;
  profileMe: IUser;
  messagesGPT: TMessageGPT[];
  isFull?: boolean;
  showUser?: string;
  btnDelete?: () => void;
  hideName?: boolean;
  cardStyles?: CSSProperties;
}

const parseText = (input: string) => {
  const cleanedInput = input.replace(/###/g, '');
  const parts = cleanedInput.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
};

const ListMessagesGPT: React.FC<IProps> = ({
  loadingMessages,
  profileMe,
  messagesGPT,
  isFull,
  showUser,
  btnDelete,
  hideName,
  cardStyles,
}) => {
  const classes = useStyle();
  const intl = useIntl();
  const scrollBarref = useRef<HTMLDivElement>(null);

  const scrollToBottom = useCallback(() => {
    scrollBarref.current && scrollBarref.current.scrollIntoView();
  }, [scrollBarref]);

  useEffect(() => {
    scrollToBottom();
  }, [loadingMessages, scrollBarref]);

  useEffect(() => {
    scrollToBottom();
  }, [messagesGPT.length]);

  return (
    <Card
      className={classes.chatCard}
      style={{
        ...cardStyles,
        width: isFull ? "100%" : undefined,
      }}
    >
      <>
        <div className={classes.chatHeader}>
          <b className={classes.chatName}>ChatGPT</b>
          <div className={classes.chatStatusWrapper}>
            <span className={classes.chatStatusIndicator} />
            <b className={classes.chatStatus}>Active</b>
          </div>
        </div>
        <PerfectScrollbar className={classes.scrollBarChat}>
          <>
            <>
              {loadingMessages ? (
                <Preloader />
              ) : (
                <>
                  {messagesGPT.map((item, index) => (
                    <div key={item.id}>
                      {item.role === "user" && index === 0 && (
                        <div className={classes.myMessage}>
                          <div className={classes.myMessageUser}>
                            <b className={classes.myMessageTime}>{formatDate(item.date, "DD.MM.YYYY HH:mm:ss", true)}</b>
                            {!hideName && <b className={classes.myMessageUserName}>{showUser || "Я"}</b>}
                            <div className={classes.chatAvatar}>
                              {showUser ? (
                                <b style={{ color: "#009ef7" }}>{showUser[0]}</b>
                              ) : (
                                <b style={{ color: "#009ef7" }}>{profileMe.login ? profileMe.login[0] : "Я"}</b>
                              )}
                            </div>
                          </div>
                          <div className={classes.myMessageTextWrapper}>
                            <div
                              className={classes.myMessageTextBlock}
                              style={{
                                padding: item.content.trim() ? "1.25rem" : 0,
                              }}
                            >
                              <b className={classes.myMessageText} dangerouslySetInnerHTML={{ __html: item.content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')  }}/>
                            </div>
                          </div>
                        </div>
                      )}
                      {item.role === "assistant" && index === 0 && (
                        <div className={classes.message}>
                          <div className={classes.messageUser}>
                            <div className={classes.chatAvatar}>
                              <b style={{ color: "#009ef7" }}>C</b>
                            </div>
                            {!hideName && <b className={classes.messageUserName}>ChatGPT</b>}
                            <b className={classes.messageUserTime}>{formatDate(item.date, "DD.MM.YYYY HH:mm:ss", true)}</b>
                          </div>
                          <div className={classes.messageTextWrapper}>
                            <b className={classes.messageText} dangerouslySetInnerHTML={{ __html: item.content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')  }}/>
                          </div>
                        </div>
                      )}
                      {item.role === "user" && index > 0 && messagesGPT[index - 1].role === "assistant" && (
                        <div className={classes.myMessage}>
                          <div className={classes.myMessageUser}>
                            <b className={classes.myMessageTime}>{formatDate(item.date, "DD.MM.YYYY HH:mm:ss", true)}</b>
                            {!hideName && <b className={classes.myMessageUserName}>{showUser || "Я"}</b>}
                            <div className={classes.chatAvatar}>
                              {showUser ? (
                                <b style={{ color: "#009ef7" }}>{showUser[0]}</b>
                              ) : (
                                <b style={{ color: "#009ef7" }}>{profileMe.login ? profileMe.login[0] : "Я"}</b>
                              )}
                            </div>
                          </div>
                          <div className={classes.myMessageTextWrapper}>
                            <div
                              className={classes.myMessageTextBlock}
                              style={{
                                padding: item.content.trim() ? "1.25rem" : 0,
                              }}
                            >
                              <b className={classes.myMessageText} dangerouslySetInnerHTML={{ __html: item.content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')  }}/>
                            </div>
                          </div>
                        </div>
                      )}
                      {item.role === "user" && index > 0 && messagesGPT[index - 1].role === "user" && (
                        <div className={classes.myMessage}>
                          <div className={classes.myMessageUser}>
                            <b className={classes.myMessageTime}>{formatDate(item.date, "DD.MM.YYYY HH:mm:ss", true)}</b>
                          </div>
                          <div className={classes.myMessageTextWrapper}>
                            <div
                              className={classes.myMessageTextBlock}
                              style={{
                                padding: item.content.trim() ? "1.25rem" : 0,
                              }}
                            >
                              <b className={classes.myMessageText}dangerouslySetInnerHTML={{ __html: item.content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')  }}/>
                            </div>
                          </div>
                        </div>
                      )}
                      {item.role === "assistant" && index > 0 && messagesGPT[index - 1].role === "user" && (
                        <div className={classes.message}>
                          <div className={classes.messageUser}>
                            <div className={classes.chatAvatar}>
                              <b style={{ color: "#009ef7" }}>С</b>
                            </div>
                            {!hideName && <b className={classes.messageUserName}>ChatGPT</b>}
                            <b className={classes.messageUserTime}>{formatDate(item.date, "DD.MM.YYYY HH:mm:ss", true)}</b>
                          </div>
                          <div className={classes.messageTextWrapper}>
                            <b className={classes.messageText}dangerouslySetInnerHTML={{ __html: item.content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')  }}/>
                          </div>
                        </div>
                      )}
                      {item.role === "assistant" && index > 0 && messagesGPT[index - 1].role === "assistant" && (
                        <div className={classes.message}>
                          <div className={classes.messageUser}>
                            <b className={classes.messageUserTime}>{formatDate(item.date, "DD.MM.YYYY HH:mm:ss", true)}</b>
                          </div>
                          <div className={classes.messageTextWrapper}>
                            <b className={classes.messageText}dangerouslySetInnerHTML={{ __html: item.content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')  }}/>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </>
              )}
            </>
            <div ref={scrollBarref} />
          </>
        </PerfectScrollbar>
        {btnDelete && (
          <Button onClick={btnDelete} variant="outlined" color="secondary">
            {intl.formatMessage({ id: "COMMON.BUTTON.DELETE" })}
          </Button>
        )}
      </>
    </Card>
  );
};

export default React.memo(ListMessagesGPT);
